import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicButton, BaasicFieldDropdown } from 'core/components';
import { toDate } from "core/utils";

function ExistingPatientDataModalTemplate({ existingPatientDataModalViewStore, t }) {
    const {
        form,
        patients,
        modalParams,
        onPatientDataChange,
        subCategoryStore,
        eligibilityStatus,
        eligibilityStatusStore,
        usIntakeStatus
    } = existingPatientDataModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Existing Brightree Patient Data</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <h4 className="type--sml u-mar--bottom--tny">Select existing patient data: </h4>
                    <div>
                        {
                            patients ? patients.map(p => {
                                const name = p.patientGeneralInfo.name;
                                const dateOfBirth = p.patientGeneralInfo.birthDate;
                                const ssn = p.patientGeneralInfo.ssn;
                                const id = p.patientGeneralInfo.ptID;
                                const patientLabel = `${name.last}, ${name.first} / DOB: ${toDate(dateOfBirth)} / SSN: ${ssn}`;

                                return (
                                    <div className="u-mar--bottom--sml u-separator--preview" key={p.brightreeID}>
                                        <input className="input--radio" type="radio" id={p.brightreeID} name="patientId" value={id} checked={id === form.$("patientId").value} onChange={() => onPatientDataChange(p)} />
                                        <label htmlFor={p.brightreeID}>{patientLabel}</label>
                                    </div>
                                );
                            }
                            ) : null
                        }
                    </div>
                </div>
                <div className="form__group">
                    <h4 className="type--sml u-mar--bottom--tny">Select sub category for new template: </h4>
                    <div>
                        <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} />
                    </div>
                </div>
                {usIntakeStatus && usIntakeStatus.completedOn && <div className="form__group">
                    <h4 className="type--sml u-mar--bottom--tny">Select patient's Eligibility Status: </h4>
                    <div className="row u-mar--tom--sml">
                        <div className="form__group col col-sml-12 col-lrg-6">
                            <BaasicFieldDropdown field={form.$('eligibilityStatusId')} store={eligibilityStatusStore} />
                        </div>
                    </div>
                    {eligibilityStatus &&
                        <div className="u-flex--default u-mar--bottom--sml">
                            <label className="type--sml type--color--opaque u-mar--right--tny">After creation, the template will be shown on the Intake Reviewed tab on the US Intake page, and on the {eligibilityStatus == "Eligible" ? "In Progress" : "Reviewed-Clinical"} tab on the Clinical Review page.</label>
                        </div>
                    }
                </div>
                }
            </div>

            <div className='modal__footer'>
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    className='btn btn--med btn--primary'
                    label="Submit"
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section>
    )
}

ExistingPatientDataModalTemplate.propTypes = {
    existingPatientDataModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ExistingPatientDataModalTemplate);
